/* =====================================================================
   sn-pdp.js — sections sous la fiche produit (JavaScript sans dépendance)
   - <sn-steps>        : étapes « Comment il fonctionne » (ronds numérotés + carrousel)
   - [data-sn-reveal]  : apparition décalée des lignes de « Le calcul »
   Le fichier peut être appelé par plusieurs sections : il ne s'exécute qu'une fois.
   ===================================================================== */
(function () {
  'use strict';
  if (window.snPdpLoaded) return;
  window.snPdpLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------------------------------------------------------------------
     Étapes
     ------------------------------------------------------------------- */
  if (!customElements.get('sn-steps')) {
    customElements.define(
      'sn-steps',
      class SnSteps extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.sn-steps__track');
          if (!this.track) return;
          this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.sn-steps__slide'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.sn-steps__dot'));
          this.lines = Array.prototype.slice.call(this.querySelectorAll('.sn-steps__line'));
          this.index = 0;
          this.raf = null;

          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
          this.track.addEventListener(
            'scroll',
            () => {
              if (this.raf) cancelAnimationFrame(this.raf);
              this.raf = requestAnimationFrame(() => this.sync());
            },
            { passive: true }
          );
          this.onResize = () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
              this.fitHeight();
              this.go(this.index, true);
            }, 250);
          };
          window.addEventListener('resize', this.onResize, { passive: true });
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(() => this.fitHeight());
            this.slides.forEach((slide) => this.observer.observe(slide));
          }

          // Éditeur de thème : sélectionner un bloc affiche son étape.
          this.onBlockSelect = (event) => {
            var i = this.slides.indexOf(event.target);
            if (i > -1) this.go(i, true);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.fitHeight();
          this.render();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          window.removeEventListener('resize', this.onResize);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        // Mobile : défilement horizontal. Ordinateur : défilement vertical (scroll-snap-type: y dans sn-pdp.css).
        isVertical() {
          var snap = window.getComputedStyle(this.track).scrollSnapType || '';
          return snap.charAt(0) === 'y';
        }

        // Ordinateur : comme le concurrent, le cadre prend la hauteur d'une étape (+ ses marges
        // intérieures) : une seule étape visible, la molette fait défiler les suivantes une à une.
        // On prend l'étape la plus haute pour qu'aucune ne soit coupée.
        fitHeight() {
          if (!this.slides.length) return;
          if (!this.isVertical()) {
            this.track.style.height = '';
            this.track.style.maxHeight = '';
            return;
          }
          var style = window.getComputedStyle(this.track);
          var tallest = 0;
          this.slides.forEach((slide) => {
            tallest = Math.max(tallest, slide.offsetHeight);
          });
          var height = Math.ceil(tallest + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
          this.track.style.height = height + 'px';
          this.track.style.maxHeight = height + 'px';
        }

        maxScroll() {
          return this.isVertical()
            ? this.track.scrollHeight - this.track.clientHeight
            : this.track.scrollWidth - this.track.clientWidth;
        }

        go(i, instant) {
          if (!this.slides.length) return;
          var target = Math.max(0, Math.min(i, this.slides.length - 1));
          this.index = target;
          var vertical = this.isVertical();
          var slide = this.slides[target];
          var position = Math.min(vertical ? slide.offsetTop : slide.offsetLeft, this.maxScroll());
          var behavior = instant || reduceMotion ? 'auto' : 'smooth';
          this.track.scrollTo(vertical ? { top: position, behavior: behavior } : { left: position, behavior: behavior });
          this.render();
        }

        sync() {
          var vertical = this.isVertical();
          var position = vertical ? this.track.scrollTop : this.track.scrollLeft;
          var best = 0;
          var distance = Infinity;
          this.slides.forEach((slide, i) => {
            var d = Math.abs((vertical ? slide.offsetTop : slide.offsetLeft) - position);
            if (d < distance) {
              distance = d;
              best = i;
            }
          });
          if (this.maxScroll() > 0 && position >= this.maxScroll() - 2) best = this.slides.length - 1;
          if (best !== this.index) {
            this.index = best;
            this.render();
          }
        }

        render() {
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === this.index);
            dot.classList.toggle('is-done', i <= this.index);
            if (i === this.index) {
              dot.setAttribute('aria-current', 'step');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
          // Le trait n°k relie le rond k au rond k + 1 : il noircit quand le rond k + 1 est atteint.
          this.lines.forEach((line, k) => line.classList.toggle('is-done', k + 1 <= this.index));
        }
      }
    );
  }

  /* -------------------------------------------------------------------
     Apparition décalée (Le calcul)
     ------------------------------------------------------------------- */
  function initReveal(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    (root || document).querySelectorAll('[data-sn-reveal]').forEach((el) => {
      if (el.dataset.snRevealReady) return;
      el.dataset.snRevealReady = 'true';
      // Déjà à l'écran (ou au-dessus) : on ne cache rien.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.85) return;
      el.classList.add('is-armed');
      var observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            observer.disconnect();
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReveal(document));
  } else {
    initReveal(document);
  }
  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));
})();
